export const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUB_KEY;
export const API_VERSION = '2020-08-27';
